export default __webpack_public_path__ + "static/media/11.68e793ee.wav";